<template>
    <v-dialog v-model="dialog" persistent width="700">
        <v-card class="clm-ops-contratar-servico">
            <v-card-title class="primary title lighten-1 white--text">
                Assinatura
                {{ tipoAssinatura.nome === 'WhatsApp' ? 'por ' + this.tipoAssinatura.nome : this.tipoAssinatura.nome }}
                <v-spacer/>

                <v-icon color="white" @click="fechar"> mdi-window-close </v-icon>
            </v-card-title>

            <v-card-text>
                <span style="color: #777777;font-size: 12px">
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </span>

                <v-flex class="row text-xs-center pt-3">
                    <iframe v-if="dialog" frameborder="0" height="345" src="https://www.youtube.com/embed/lTiA_MPU3sc"
                            width="420"></iframe>
                </v-flex>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'DialogInfoTipoAssinatura',
    props: {
        dialog: {
            type: Boolean,
            required: true
        },
        tipoAssinatura: {
            type: Object,
            required: true
        }
    },
    methods: {
        abrirChatSuporte() {
            this.$chat.toggle()
        },
        fechar() {
            this.$emit('fechar')
        }
    }
}
</script>

<style lang="stylus">
.clm-ops-contratar-servico
    .texto
        color: #aaaaaa
        margin 10px 40px
</style>